import { render, staticRenderFns } from "./AppPageCard.vue?vue&type=template&id=b7d7d350&scoped=true&"
import script from "./AppPageCard.vue?vue&type=script&lang=js&"
export * from "./AppPageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d7d350",
  null
  
)

export default component.exports